export default __webpack_public_path__ + "static/media/meraki-product-page.e45620c9.svg";